import { sheetServerRequest } from '../../apiRequests'

/**
 * Start a new connector configuration conversation
 * @param {Object} params
 * @param {string} params.connectorType - e.g., "HubSpot"
 * @param {string} params.connectionKey - From OAuth connection
 * @param {string} params.workspaceID - Current workspace
 */
export const startExtractConversation = async ({ connectorType, connectionKey, workspaceID }) => {
    const action = {
        action: 'startExtractConversation',
        connectorType,
        connectionKey,
        workspaceID,
    }
    return await sheetServerRequest(action)
}

/**
 * Select a preset or provide custom intent
 * @param {Object} params
 * @param {string} params.sessionId - Conversation session ID
 * @param {string} params.presetId - Preset ID (e.g., "sales_pipeline" or "something_else")
 * @param {string} [params.customIntent] - Custom intent text (required when presetId is "something_else")
 */
export const selectExtractPreset = async ({ sessionId, presetId, customIntent }) => {
    const action = {
        action: 'selectExtractPreset',
        sessionId,
        presetId,
        ...(customIntent && { customIntent }),
    }
    return await sheetServerRequest(action)
}

/**
 * Modify the current configuration via natural language
 * @param {Object} params
 * @param {string} params.sessionId - Conversation session ID
 * @param {string} params.modification - Natural language modification request
 */
export const modifyExtractConfig = async ({ sessionId, modification }) => {
    const action = {
        action: 'modifyExtractConfig',
        sessionId,
        modification,
    }
    return await sheetServerRequest(action)
}

/**
 * Accept the current configuration
 * @param {Object} params
 * @param {string} params.sessionId - Conversation session ID
 */
export const acceptExtractConfig = async ({ sessionId }) => {
    const action = {
        action: 'acceptExtractConfig',
        sessionId,
    }
    return await sheetServerRequest(action)
}

/**
 * Cancel the conversation and cleanup
 * @param {Object} params
 * @param {string} params.sessionId - Conversation session ID
 */
export const cancelExtractConversation = async ({ sessionId }) => {
    const action = {
        action: 'cancelExtractConversation',
        sessionId,
    }
    return await sheetServerRequest(action)
}
